import React from 'react';

import { logo } from './PSLogo.scss';
import Logo from './assets/ps-logo.svg';

const PSLogo: React.FC = () => <Logo className={logo} />;

export default PSLogo;
